import React, { useEffect, useState } from "react";
import { HiMiniArrowsRightLeft } from "react-icons/hi2";
import Select from "../../Components/Select";
import Input from "../../Components/Input";

const Property = (props) => {
  const { userQuery, setUserQuery, activeButton, errors } = props;
  const [cityOptions, setCityOptions] = useState([]);

  //Options for propertyType dropdown

  const optiontype = [
    { value: "SFH", label: "Single Family" },
    { value: "2-Unit", label: "2-Unit" },
    { value: "3-Unit", label: "3-Unit" },
    { value: "4-Unit", label: "4-Unit" },
    { value: "Condo", label: "Condo" },
    { value: "Co-Op", label: "Co-Op" },
    { value: "PUD-Attached", label: "PUD-Attached" },
    { value: "PUD-Detached", label: "PUD-Detached" },
  ];

  //  Options for map method in (City) section.

  const optionstate = [
    { value: "NY", label: "NY" },
    { value: "NV", label: "NV" },
    { value: "NM", label: "NM" },
    { value: "NJ", label: "NJ" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
    { value: "NY", label: "NY" },
  ];

  // useEffect(() => {
  //   console.log("UserQuery", userQuery.state);
  // }, [userQuery]);

  const handleInputChange = (field, value) => {
    console.log(value);
    setUserQuery({ ...userQuery, [field]: value });
    // if (field === "zip") {
    //   fetchCityByZip(value);
    // }
  };
  useEffect(() => {
    if (userQuery?.zip) {
      fetchCityByZip(userQuery?.zip);
    }
  }, [userQuery?.zip]);
  // const fetchCityByZip = async (zip) => {
  //   try {
  //     const response = await fetch(
  //       `https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=AIzaSyDiIPzHeT0PL00i5fklk3fNjot8JlGmRyo`
  //     );
  //     const data = await response.json();
  //     console.log("Geocoding API response:", data);

  //     // Check if response status is OK
  //     if (data.status === "OK") {
  //       const cityName = data.results[0].address_components.find((component) =>
  //         component.types.includes("locality")
  //       );
  //       // Check if cityName is found
  //       if (cityName) {
  //         setUserQuery({ ...userQuery, city: cityName.long_name });
  //       } else {
  //         console.error("City name not found in response data");
  //       }
  //     } else {
  //       console.error("Geocoding API error:", data.error_message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching city by zip:", error);
  //   }
  // };
  const fetchCityByZip = async (zip) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=AIzaSyDiIPzHeT0PL00i5fklk3fNjot8JlGmRyo`
      );
      const data = await response.json();
      console.log("Geocoding API response:", data);
      console.log("userQuery", userQuery);
      // Check if response status is OK
      if (data.status === "OK") {
        const cityName = data.results[0].formatted_address.split(",")[0];
        setUserQuery({ ...userQuery, city: cityName });
      } else {
        console.error("Geocoding API error:", data.error_message);
      }
    } catch (error) {
      console.error("Error fetching city by zip:", error);
    }
  };
  return (
    <div className="text-[#333] w-full bg-white p-12 rounded-xl">
      {/* Heading */}

      <div className="flex items-center">
        <h1 className=" px-4 py-1 text-[#333]   text-lg  font-semibold	">
          Property Information
        </h1>
        <h3 className="  text-[#037dfa]  text-xs font-medium   cursor-pointer  ">
          Learn More
        </h3>
      </div>
      <div className="flex flex-col px-2 xl:p-4 ">
        {/* Property Type */}

        <div className="flex space-x-12 mb-6">
          <div className="w-full">
            <Select
              label={"Property Type"}
              options={optiontype}
              value={userQuery.property_type}
              handlechange={(e) =>
                handleInputChange("property_type", e.target.value)
              }
            />
          </div>
          {/* Zip */}
          <div className="w-full">
            <Input
              Label={"Zip"}
              value={userQuery.zip}
              handlechange={(e) => handleInputChange("zip", e.target.value)}
              Placeholder={"4400"}
              type={"number"}
            />
          </div>
        </div>
        <div className="flex space-x-12 ">
          {/* City */}

          <Input
            Label={"City"}
            value={userQuery.city}
            handlechange={(e) => handleInputChange("city", e.target.value)}
            Placeholder={"New York"}
          />
          <Select
            label={"State"}
            value={userQuery.state}
            options={optionstate}
            handlechange={(e) => handleInputChange("state", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Property;
